export const API_NAME = `${process.env.REACT_APP_AWS_NAMESPACE}-lambda`;
export const REGION = process.env.REACT_APP_AWS_REGION;
export const ENVIRONMENT = process.env.REACT_APP_AWS_NAMESPACE;
export const NEXPYN_BUCKET = `${process.env.REACT_APP_AWS_NAMESPACE}-image`;
export const NEXPYN_CONDITION_REPORT_API = `${process.env.REACT_APP_AWS_CONDITION_REPORT_API}`;
export const MESSAGE_DURATION = 5;